// src/components/ProjectManagement/AddTaskModal.jsx
import React, { useState } from 'react';

const AddTaskModal = ({ onClose, onAdd }) => {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: 'General',
    startDate: new Date().toISOString().split('T')[0],
    endDate: '',
    priority: 'normal'
  });
  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    'Planning', 'Design', 'Production', 'Assembly', 
    'Finishing', 'Quality Control', 'Delivery', 'Installation', 'General'
  ];

  const handleSubmit = async () => {
    if (!formData.title.trim()) {
      alert('Please enter a task title');
      return;
    }
    if (!formData.endDate) {
      alert('Please select an end date');
      return;
    }

    setIsLoading(true);
    await onAdd(formData);
    setIsLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '550px' }}>
        <h3>➕ Add New Task</h3>
        <p style={{ color: '#666', marginBottom: '20px', fontSize: '13px' }}>
          Create a new task for this project
        </p>

        <label>Task Title *</label>
        <input 
          type="text"
          value={formData.title}
          onChange={(e) => setFormData({...formData, title: e.target.value})}
          placeholder="e.g., Install custom lighting"
          required
        />

        <label>Description (Optional)</label>
        <textarea 
          value={formData.description}
          onChange={(e) => setFormData({...formData, description: e.target.value})}
          placeholder="Detailed description of what needs to be done..."
          rows="3"
        />

        <label>Category</label>
        <select 
          value={formData.category}
          onChange={(e) => setFormData({...formData, category: e.target.value})}
        >
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div>
            <label>Start Date</label>
            <input 
              type="date"
              value={formData.startDate}
              onChange={(e) => setFormData({...formData, startDate: e.target.value})}
            />
          </div>
          <div>
            <label>End Date *</label>
            <input 
              type="date"
              value={formData.endDate}
              onChange={(e) => setFormData({...formData, endDate: e.target.value})}
              required
            />
          </div>
        </div>

        <label>Priority</label>
        <select 
          value={formData.priority}
          onChange={(e) => setFormData({...formData, priority: e.target.value})}
        >
          <option value="urgent">🔴 Urgent</option>
          <option value="high">🟠 High</option>
          <option value="normal">🔵 Normal</option>
          <option value="low">🟢 Low</option>
        </select>

        <div className="modal-actions">
          <button onClick={handleSubmit} className="assign-btn" disabled={isLoading}>
            {isLoading ? 'Adding...' : '✓ Add Task'}
          </button>
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTaskModal;